import React from 'react';
import { Snackbar, Avatar, Typography, Box, Paper } from '@mui/material';

const SnackBarMessage = ({
    isSnackbarOpen,
    snackBarMessage,
    snackBarDuration,
    snackBarPosition,
    setIsSnackbarOpen,
}) => {
    const handleClose = () => setIsSnackbarOpen(false);

    const { sender = {}, text = '' } = snackBarMessage || {};

    const customMessage = (
        <Paper
            elevation={3}
            sx={{
                background: 'var(--theme-bg-light)',
                borderRadius: 2,
                minWidth: '300px',
                overflow: 'hidden',
            }}
        >
            <Box alignItems="center" gap={1} sx={{ px: 2, pt: 1 }}>
                <Typography sx={{ fontSize: 'medium' }}>
                    New message received!
                </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1} sx={{ p: 2 }}>
                <Avatar src={sender.avatar} alt={sender.name} sx={{ marginBottom: 'auto' }} />
                <Typography fontWeight={600}>
                    {sender.name}
                    <br />
                    <Typography
                        variant="body2"
                        sx={{
                            whiteSpace: 'pre-line', // 👈 handles \n and preserves line breaks
                            color: 'text.secondary',
                        }}
                    >
                        {text}
                    </Typography>
                </Typography>
            </Box>
        </Paper>
    );

    return (
        <Snackbar
            open={isSnackbarOpen}
            autoHideDuration={snackBarDuration * 1000}
            onClose={handleClose}
            anchorOrigin={snackBarPosition}
            message={customMessage}
            ContentProps={{
                sx: {
                    padding: 0,
                    background: 'transparent',
                    boxShadow: 'none',
                    minWidth: '300px'
                },
            }}
        />
    );
};

export default SnackBarMessage;
